<template>
  <common-query :query="query" @query="onClickQuery">
    <el-form-item label="商户名称">
      <el-input v-model="query.merName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="商户号">
      <el-input v-model="query.merNo" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="供应商名称">
      <el-input v-model="query.supName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="供应商号">
      <el-input v-model="query.supId" placeholder="请输入" />
    </el-form-item>

    <el-form-item label="交易状态">
      <common-select v-model="query.status" :list="tradingStatus" />
    </el-form-item>
    <el-form-item label="渠道路由">
      <common-select v-model="query.bankCode" :list="channelRouting" />
    </el-form-item>
    <el-form-item label="交易流水号">
      <el-input v-model="query.orderId" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="交易时间" class="auto-width">
      <date-picker v-model="query.startTime" />
      <span class="middle-text">至</span>
      <date-picker v-model="query.endTime" />
    </el-form-item>
  </common-query>
</template>

<script>
export default {
  props: {
    query: {
      type: Object,
      default() {
        return {
          bankCode: '', // 渠道路由-code
          bankName: '', // 渠道
          companyId: '', // 收单机构/管辖机构
          endTime: '', // 交易结束时间
          merName: '', // 交易商户
          merNo: '', // 商户号
          orderId: '', // 交易流水号
          startTime: '', // 交易开始时间
          status: '', // 交易状态
          supId: '', // 供应商号
          supName: '' // 供应商
        }
      },
      comment: '查询条件'
    },
    tradingStatus: {
      type: Array,
      default() {
        return []
      },
      comment: '交易状态'
    },
    channelRouting: {
      type: Array,
      default() {
        return []
      },
      comment: '渠道路由'
    }
  },

  methods: {
    onClickQuery() {
      this.$emit('query', this.query)
    }
  }
}
</script>
